// extracted by mini-css-extract-plugin
module.exports = {"EmailVerification":"_2es0Kcyu","title":"_3E77Z_Kt","buttonContainer":"_3q44U_q1","button":"j8ZvNs_s","loader":"qXhIF3St","content":"_2a232VFx","divider":"_3hNwgWhv"};